import { apiClient } from '../apiClient'

const gqlApiUrl = '/graphql'

export const getLoginInitData = async () => {
  return apiClient.postGql(gqlApiUrl, {
    query: `
      {
        loginInitData {
          fbAuthenticateUrl
          blvdFbIntegrations {
            fbBlvdBusinessId
            pageName
            hasFb
            hasIg
            igName
            fbEnabled
            igEnabled
          }
        }
      }
    `
  })
}

export const uninstallAuth = async (fbBlvdBusinessId: string) => {
  return apiClient.postGql(gqlApiUrl, {
    query: `
      mutation {
        uninstallAuth(
          fbBlvdBusinessId: "${fbBlvdBusinessId}"
        )
      }
    `
  })
}

export const disableEnableFb = async (fbBlvdBusinessId: string) => {
  return apiClient.postGql(gqlApiUrl, {
    query: `
      mutation {
        disableEnableFb(
          fbBlvdBusinessId: "${fbBlvdBusinessId}"
          fbEnabled: false
        )
      }
    `
  })
}

export const exchangeFbCodeForAccessToken = async (code: string, fbBusinessId: string) => {
  return apiClient.postGql(gqlApiUrl, {
    query: `
      mutation {
        exchangeFbCodeForAccessToken(
          code: "${code}"
          fbBusinessId: "${fbBusinessId}"
        )
      }
    `
  })
}
